import { Injectable } from '@angular/core';
import { LogService } from '../../../../shared/services/log.service';
import { FeatureService } from '../../services/feature.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NavigationItem } from '../navigation_item';
import { ENV } from '../../../../environment';
import { RedirectService } from '../../../../shared/services/redirect.service';
import {
  INTEGRATE_SETUP_PATH, INTEGRATE_LAST_STEP_PATH, PLANS_PAGE,
  INSTALLATION_FINISH_STATUS, QUERY_PARAMS
} from '../constants';
import { catchError, map, take } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class NavigationEffectsService {

  constructor(private logger: LogService,
              private featureService: FeatureService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private redirectService: RedirectService) { }

  navigateToStep(activeStep: NavigationItem) {
    this.router.navigate([activeStep.url], { relativeTo: this.activatedRoute, queryParams: {
        [QUERY_PARAMS.PLAN]: this.activatedRoute.snapshot.queryParams[QUERY_PARAMS.PLAN]
      }
    });
  }

  setStepFeatureSettings(activeStep: NavigationItem) {
    let nextStep = activeStep.nextStep;

    this.featureService.getFeatureSettings('InstallationV2').pipe(take(1)).subscribe(
      (installationSettings) => {
        let installationStepSettings = installationSettings.response.step;
        if (this.isAdvancedStep(nextStep, installationStepSettings)) {
          this.featureService.setFeatureSettings('InstallationV2', {settings: {step: nextStep.url}}).pipe(
            take(1)
          ).subscribe(() => {},
              (error) => this.logger.log(error));
        }
      });
  }

  navigateToB2B() {
    const plan = this.activatedRoute.snapshot.queryParams[QUERY_PARAMS.PLAN];
    const isFreePlan = /free/i.test(plan);
    let redirectUrl = ENV.YotpoNewB2bEndpoint;

    if (plan && !isFreePlan) {
      redirectUrl += `${PLANS_PAGE}?plan=${plan}`;
    }

    this.redirectService.redirectTo(redirectUrl);
  }

  setFinishInstallationSettings() {
    const settings = {
      install_status: INSTALLATION_FINISH_STATUS
    };
    return this.featureService.setFeatureSettings('InstallationV2', { settings }).pipe(
      take(1),
      catchError(error => {
        this.logger.error('fails to update InstallationV2 feature settings - ' +
          JSON.stringify(error));
        this.navigateToB2B();
        return of({});
      }),
      map(() => this.navigateToB2B())
    );
  }

  navigateToManualInstall() {
    this.router.navigate([INTEGRATE_LAST_STEP_PATH]);
  }

  navigateToIntegrateMainScreen() {
    this.router.navigate([INTEGRATE_SETUP_PATH]);
  }

  private isAdvancedStep(navigationStep: NavigationItem, itemUrl: string) {
    let prevStep = navigationStep.prevStep;
    if (prevStep) {
      if (prevStep.url === itemUrl) {
        return true;
      }
      return this.isAdvancedStep(prevStep, itemUrl);
    }
    return false;
  }
}
